import { useTranslation } from "react-i18next";

import {
  CombinationRulePostSchema,
  useCreateCombinationRule,
  useUpdateCombinationRule,
} from "~/entity/CombinationRules";
import { useNotify } from "~/shared/hooks/useNotify";

export type RuleFormSelectValue = { label: string; value: number | string };

export interface RuleConditionFormValue {
  conditionType?: RuleFormSelectValue;
  postIds?: RuleFormSelectValue[];
  operator?: RuleFormSelectValue;
  value?: string;
  category?: RuleFormSelectValue[];
}

export interface RuleGroupFormValue {
  isActive: boolean;
  dealerIds?: RuleFormSelectValue[];
  conditions: RuleConditionFormValue[];
}

export const emptyCondition = (): RuleConditionFormValue => ({
  conditionType: undefined,
  postIds: [],
  operator: undefined,
  value: "",
  category: [],
});

export const emptyGroup = (): RuleGroupFormValue => ({
  isActive: true,
  dealerIds: [],
  conditions: [emptyCondition()],
});

export const defaultValues = {
  mainPositionId: undefined,
  additionalPositionIds: [] as RuleFormSelectValue[],
  rolePositionIds: [] as RuleFormSelectValue[],
  maxPerEmployee: "",
  groups: [emptyGroup()] as RuleGroupFormValue[],
};

export const ruleQueryManagement = ({ refetch, closeModal }) => {
  const { notifyError, notifySuccess } = useNotify();
  const { t } = useTranslation();
  const { create } = useCreateCombinationRule();
  const { update } = useUpdateCombinationRule();

  const onSuccess = async () => {
    await refetch();
    closeModal();
    notifySuccess(t("common.сhange_was_successful"));
  };

  const onError = (error) => {
    notifyError(error?.message || t("combinationRules.request_error"));
  };

  const editRule = (id: string, data: CombinationRulePostSchema) => {
    update(id, data, { onSuccess, onError });
  };

  const addRule = (data: CombinationRulePostSchema) => {
    create(data, { onSuccess, onError });
  };

  return { editRule, addRule };
};
